import CommonStore from '../../../stores/common.store';

const useMapConfig = () => ({
  trimbleMapsDirectionConfig: CommonStore.trimbleMapsDirectionConfig,
});

export default useMapConfig;
